export const addNewShiftSuccess = 'ADD_NEW_SHIFT_SUCCESS';
export const addNewShiftFailure = 'ADD_NEW_SHIFT_FAILURE';
export const getAllShiftSuccess = 'GET_ALL_SHIFT_SUCCESS';
export const getAllShiftFailure = 'GET_ALL_SHIFT_FAILURE';
export const editShiftSuccess = 'EDIT_ALL_SHIFT_SUCCESS';
export const editShiftFailure = 'EDIT_ALL_SHIFT_FAILURE';
export const deleteShiftSuccess = 'DELETE_ALL_SHIFT_SUCCESS';
export const deleteShiftFailure = 'DELETE_ALL_SHIFT_FAILURE';